export const SYSTEM_EVENT_DEFINITION_TYPE = "system-notifications-v1";
export const TACTICS_TECHNIQUES_ATTRIBUTE_ID = "tactics_techniques";
const getEventDefinitionTableElements = (pluggableAttributes, tacticsTechniquesAttribute) => {
  const defaultLayout = {
    entityTableId: "event_definitions",
    defaultPageSize: 20,
    defaultSort: { attributeId: "title", direction: "asc" },
    defaultDisplayedAttributes: [
      "title",
      "description",
      "priority",
      "notifications",
      "scheduling",
      "status",
      "matched_at",
      "tags",
      ...tacticsTechniquesAttribute ? [tacticsTechniquesAttribute.id] : []
    ],
    defaultColumnOrder: [
      "title",
      "description",
      "priority",
      "notifications",
      "_entity_source.source",
      "matched_at",
      "status",
      "type",
      "scheduling",
      "tags",
      ...tacticsTechniquesAttribute ? [tacticsTechniquesAttribute.id] : [],
      ...(pluggableAttributes == null ? void 0 : pluggableAttributes.attributeNames) || []
    ]
  };
  const additionalAttributes = [
    { id: "scheduling", title: "Scheduling", sortable: false },
    { id: "matched_at", title: "Last Matched", sortable: true },
    { id: "notifications", title: "Notifications", sortable: false },
    ...(pluggableAttributes == null ? void 0 : pluggableAttributes.attributes) || []
  ];
  return {
    defaultLayout,
    additionalAttributes
  };
};
export default getEventDefinitionTableElements;
